import { getDiscoCompanyMenuItems } from "../../components/AdminCompanySelect/DiscoCompanyMenuItems";
import React, { forwardRef, useEffect, useState } from "react";
import { clampIsoDateToToday, getReportDateInputProps } from "../../utils/reportDateLimits";
import { useLocation } from "react-router-dom";
// MUI
import CloseIcon from "@mui/icons-material/Close";
import FilterListIcon from "@mui/icons-material/FilterList";
import {
  Backdrop,
  Box,
  Grid,
  Typography,
  MenuItem,
  Select,
  Button,
  Snackbar,
  Alert,
  Drawer,
  FormControl,
  IconButton,
  Paper,
  Stack,
  Tooltip,
} from '@mui/material';
import TextField from '../../components/SanitizedTextField/SanitizedTextField';
import AppLoader from '../../components/AppLoader/AppLoader';
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import StepProgressBar from "../../components/StepProgressBar/StepProgressBar";
import CheckPermissions from "../../authorization/authorization";
import "../../style/common.scss";
import ReportExportButtons from "./components/ReportExportButtons";
import "./reportPageLayout.scss";
import "./ChangeOfAttributesStatusReport.scss";
import "./NewConnectionPostedToIBSReport.scss";
import {
  renderCircleValue,
  renderDivisionValue,
  renderSubDivisionValue,
} from "./coaHierarchySelectRenderers";
import useScanDetection from "use-scan-detection";
import { useDispatch, useSelector } from "react-redux";
import BasicTable from "../../components/basicTable/basicTable";
import { tableStyle } from "../../style/common";
import {
  fetchCOASRDataForEmail,
  nextPage,
  previousPage,
  resetState,
} from "../../features/generalServices/getCOASRDataForEmailSlice";
import { openJsPdfInNewTab, convertDateYYYYMMDD,
  convertDatewithTime,
  subdivisionName,
  toTitleCase,
  convertDate,
  permissionsVariables,
  getName,
} from "../../services/Functions";
import { cfpBaseUrl } from "../../network/urls";
import FESCOLOGO from "../../images/DISCO Logos/FESCO.png";
import GEPCOLOGO from "../../images/DISCO Logos/GEPCO.png";
import HESCOLOGO from "../../images/DISCO Logos/HESCO.png";
import IESCOLOGO from "../../images/DISCO Logos/IESCO.png";
import MEPCOLOGO from "../../images/DISCO Logos/MEPCO.png";
import LESCOLOGO from "../../images/DISCO Logos/LESCO.png";
import PESCOLOGO from "../../images/DISCO Logos/PESCO.png";
import QESCOLOGO from "../../images/DISCO Logos/QESCO.png";
import SEPCOLOGO from "../../images/DISCO Logos/SEPCO.png";
import TESCOLOGO from "../../images/DISCO Logos/TESCO.png";
import HAZECOLOGO from "../../images/DISCO Logos/HAZECO.jpg";
import pitcLogo from "../../images/pitc.png";
import eOpsLogo from "../../images/eops.png";
import jsPDF from "jspdf";
import XLSX, { boldRows } from "utils/xlsxStyled";
import { saveAs } from "file-saver";
import closeIconWhite from "../../images/close_icon_white.png";
import { resolveOfficeCodeForAdmin, getInitialAdminOfficeCode, getEffectiveAdminCompanyCode, resolveReportGoOfficeCode } from "../../utils/adminCompany";

const COASRonEmail = forwardRef((props, ref) => {
  // Initial values
  const ComplaintStatusBarArray = [
    { title1: "COMPLAINT", title2: "RECEIVED" },
    { title1: "ASSIGNED TO", title2: "FIELD STAFF" },
    { title1: "COMPLAINT", title2: "RESOLVED" },
    { title1: "COMPLAINT", title2: "CLOSED" },
    { title1: "REOPENED BY", title2: "CALL CENTER" },
  ];

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const [selectedLineman, setSelectedLineman] = useState("");
  const [dateFrom, setDateFrom] = useState(getCurrentDate());
  const [dateTo, setDateTo] = useState(getCurrentDate());
  const [selectedRequisitions, setSelectedRequisitions] = useState([]);
  const [emailPopupOpen, setEmailPopupOpen] = useState(false);
  const [shouldShowData, setShouldShowData] = useState(false);
  const [email, setEmail] = useState("");
  const [tableFromSrSearch, setTableFromSrSearch] = useState(false);

  const [searchSRNo, setSearchSRNo] = useState("");

  const getCompanies = (code) => {
    switch (code) {
      case "10":
        return "Power Information Technology Company";
      case "11":
        return "Lahore Electric Supply Company";
      case "12":
        return "Gujranwala Electric Power Company";
      case "13":
        return "Faisalabad Electric Supply Company";
      case "14":
        return "Islamabad Electric Supply Company";
      case "15":
        return "Multan Electric Power Company";
      case "26":
        return "Peshawar Electric Supply Company";
      case "27":
        return "Hazara Electric Supply Company";
      case "37":
        return "Hyderabad Electric Supply Company";
      case "38":
        return "Sukkur Electric Power Company";
      case "48":
        return "Quetta Electric Supply Company";
      case "59":
        return "Tribal Electric Supply Company";
      default:
        return "";
    }
  };

  const getLogo = (code) => {
    switch (code) {
      case "10":
        return pitcLogo;
      case "11":
        return LESCOLOGO;
      case "12":
        return GEPCOLOGO;
      case "13":
        return FESCOLOGO;
      case "14":
        return IESCOLOGO;
      case "15":
        return MEPCOLOGO;
      case "26":
        return PESCOLOGO;
      case "27":
        return HAZECOLOGO;
      case "37":
        return HESCOLOGO;
      case "38":
        return SEPCOLOGO;
      case "48":
        return QESCOLOGO;
      case "59":
        return TESCOLOGO;
      default:
        return MEPCOLOGO;
    }
  };

  // Redux and state
  const {
    token,
    roleId,
    roleName: userRole,
    name: userName,
    code,
    hierarchy: userHierarchy,
    userId,
    cfcLevelId,
    cscID,
    roleTypeName,
    permissions, selectedAdminCompanyCode } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const {
    pageNumber = 1,
    pageSize = 20,
    data = [],
    totalPages = 0,
    totalRecords = 0,
    isLoading = false,
    error = null,
    dateFrom: reduxDateFrom = "",
    dateTo: reduxDateTo = "",
  } = useSelector((state) => state.getCOASRDataForEmail || {});

  const offCode =
    userHierarchy == 1
      ? code
      : userHierarchy == 2
      ? code.slice(0, 2)
      : userHierarchy == 3
      ? code.slice(0, 3)
      : userHierarchy == 4
      ? code.slice(0, 4)
      : userHierarchy == 5
      ? code.slice(0, 5)
      : code;
  const companyCode = code.slice(0, 2);
  const [selectedCompanyCode, setSelectedCompanyCode] = useState(
    getInitialAdminOfficeCode(code, selectedAdminCompanyCode),
  );

  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedSubDivision, setSelectedSubDivision] = useState("");
  const [subDivisions, setSubDivisions] = useState(
    JSON.parse(window.localStorage.getItem("subDivisions")) || []
  );
  const [officeCode, setOfficeCode] = useState("");
  const [officeName, setOfficeName] = useState("");
  const [apiData, setApiData] = useState([]);
  const [circleName, setCircleName] = useState("");
  const [circleCode, setCircleCode] = useState("");
  useEffect(() => {
    if (String(code) === "10" && selectedAdminCompanyCode) {
      const company = String(selectedAdminCompanyCode);
      setSelectedCompanyCode(company);
      setOfficeCode(company);
    }
  }, [code, selectedAdminCompanyCode]);

  useEffect(() => {
    if (String(code) !== "10") return;
    if (circleCode || selectedDivision || selectedSubDivision) return;
    const company = getEffectiveAdminCompanyCode(
      code,
      selectedCompanyCode,
      selectedAdminCompanyCode,
    );
    if (company) {
      setOfficeCode(company);
    }
  }, [
    code,
    selectedCompanyCode,
    selectedAdminCompanyCode,
    circleCode,
    selectedDivision,
    selectedSubDivision,
  ]);
  const [filteredSubDivisions, setFilteredSubDivisions] = useState([]);
  const [hierarchy, setHierarchy] = useState("");
  const [filteredDivisions, setFilteredDivisions] = useState([]);
  const [filteredCircles, setFilteredCircles] = useState([]);
  const [powerComplaints, setPowerComplaints] = useState([]);
  const [powerComplaintsToDataGrid, setPowerComplaintsToDataGrid] = useState(
    []
  );
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [showComplaintForm, setShowComplaintForm] = useState(false);
  const [searchedTrackingId, setSearchedTrackingId] = useState("");
  const [priority, setPriority] = useState("1");
  const [userIds, setUserIds] = useState([]);
  const [viewBackdrop, setViewBackdrop] = useState(false);
  const { state } = useLocation();
  const { foundId } = state || { foundId: "" };
  const [foundInNc, setFoundInNc] = useState(foundId);
  const location = useLocation();
  const currentPath = location.pathname;
  const [isGoDisabled, setIsGoDisabled] = useState(false);
  const [lastAppliedFilters, setLastAppliedFilters] = useState(null);
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
  const isPhone = useMediaQuery(theme.breakpoints.down("sm"));
  const [mobileFilterOpen, setMobileFilterOpen] = useState(false);

  function formatDate(dateString) {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    if (isNaN(date)) return "N/A";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${day}-${month}-${year} ${hours}:${minutes}`;
  }

  const resetTableData = () => {
    setPowerComplaints([]);
    setPowerComplaintsToDataGrid([]);
  };

  const apiToDataGridConversion = () => {
    const tempArray = [];
    const sortedComplaints = [...powerComplaints].sort(
      (a, b) => a.serialNo - b.serialNo
    );
    sortedComplaints.forEach((item) => {
      if (item.applicationId) {
        const dataGridObject = {
          srNo: item.serialNo,
          applicationId: item.applicationId,
          applicantName: item.applicantName,
          applicantCNIC: item.applicantCNIC,
          connectionAccountNo: item.connectionAccountNo,
          storeRequisitionNo: item.storeRequisitionNo,
          storeRequisitionDate: formatDate(item.storeRequisitionDate),
          newConProgStatusName: item.newConProgStatusName,
        };
        tempArray.push(dataGridObject);
      }
    });
    setPowerComplaintsToDataGrid(tempArray);
  };

  const handleRowClick = async (params) => {
    const matchedData = data.filter(
      (item) => item.applicationId === params.applicationId
    );
    if (matchedData.length > 0) {
      setSelectedMarker(matchedData);
      setShowComplaintForm(true);
    }
  };

  const handleNextPage = () => {
    setViewBackdrop(true);
    dispatch(nextPage());
    dispatch(
      fetchCOASRDataForEmail({
        pageNumber: pageNumber + 1,
        pageSize,
        dateFrom: convertDateYYYYMMDD(dateFrom),
        dateTo: convertDateYYYYMMDD(dateTo),
        officeCode,
      })
    );
  };

  const handlePreviousPage = () => {
    if (pageNumber > 1) {
      setViewBackdrop(true);
      dispatch(previousPage());
      dispatch(
        fetchCOASRDataForEmail({
          pageNumber: pageNumber - 1,
          pageSize,
          dateFrom: convertDateYYYYMMDD(dateFrom),
          dateTo: convertDateYYYYMMDD(dateTo),
          officeCode,
        })
      );
    }
  };

  const handleFirstPage = () => {
    setViewBackdrop(true);
    dispatch(
      fetchCOASRDataForEmail({
        pageNumber: 1,
        pageSize,
        dateFrom: convertDateYYYYMMDD(dateFrom),
        dateTo: convertDateYYYYMMDD(dateTo),
        officeCode,
      })
    );
  };

  const handleLastPage = () => {
    setViewBackdrop(true);
    dispatch(
      fetchCOASRDataForEmail({
        pageNumber: totalPages,
        pageSize,
        dateFrom: convertDateYYYYMMDD(dateFrom),
        dateTo: convertDateYYYYMMDD(dateTo),
        officeCode,
      })
    );
  };

  const fetchData = (pageNumber, pageSize, dateFrom, dateTo, officeCode) => {
    setViewBackdrop(true);
    dispatch(
      fetchCOASRDataForEmail({
        pageNumber,
        pageSize,
        dateFrom,
        dateTo,
        officeCode,
      })
    );
  };

  const getLineDataComplaints = async (code, hierarchy) => {
    setViewBackdrop(true);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      officeCode:
        hierarchy == 52 || hierarchy == 5
          ? code
          : hierarchy == 51 || hierarchy == 4
          ? code.toString().slice(0, 4)
          : hierarchy == 3
          ? code.toString().slice(0, 3)
          : hierarchy == 2
          ? code.toString().slice(0, 2)
          : hierarchy == 1
          ? code
          : code,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        cfpBaseUrl + "workForce/getAllEmployeesList",
        requestOptions
      );
      const result = await response.json();
      if (result.data) {
        const currentHour = new Date().getHours();
        let currentShift;
        if (currentHour >= 6 && currentHour < 14) {
          currentShift = "1";
        } else if (currentHour >= 14 && currentHour < 22) {
          currentShift = "2";
        } else {
          currentShift = "3";
        }

        const filteredUsers = result.data.filter((user) => {
          const shiftIdsRaw =
            typeof user.shiftIds === "string" ? user.shiftIds : "";
          const shiftIdsArray = shiftIdsRaw.replace(/\s+/g, "").split(",");
          return shiftIdsArray.includes(currentShift);
        });
        setUserIds(filteredUsers);
      }
    } catch (error) {
    } finally {
      setViewBackdrop(false);
    }
  };

  const handleLinemanChange = (event) => {
    setSelectedLineman(event.target.value);
  };

  useEffect(() => {
    if (code == 10 && selectedCompanyCode) {
      const fetchSubDivisions = async () => {
        setViewBackdrop(true);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        const formdata = new FormData();
        formdata.append("companyCode", selectedCompanyCode);
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: formdata,
          redirect: "follow",
        };
        try {
          const response = await fetch(
            cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
            requestOptions
          );
          if (response.ok) {
            const result = await response.json();
            if (result.status === "200") {
              setSubDivisions(result.message);
              setApiData(result.message);
              const circles = result.message.reduce((acc, curr) => {
                if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                  acc.push({
                    circleCode: curr.circleCode,
                    circleName: curr.circleName,
                    companyCode: curr.companyCode,
                  });
                }
                return acc;
              }, []);
              setFilteredCircles(circles);
            } else {
              setSubDivisions([]);
              setFilteredCircles([]);
            }
          } else {
            throw new Error(`Request failed with status ${response.status}`);
          }
        } catch (error) {
          setSubDivisions([]);
          setFilteredCircles([]);
        } finally {
          setViewBackdrop(false);
        }
      };
      fetchSubDivisions();
    } else if (code != 10) {
      const circles = subDivisions.reduce((acc, curr) => {
        if (!acc.some((item) => item.circleCode === curr.circleCode)) {
          acc.push({
            circleCode: curr.circleCode,
            circleName: curr.circleName,
            companyCode: curr.companyCode,
          });
        }
        return acc;
      }, []);
      setFilteredCircles(circles);
    }
  }, [code, selectedCompanyCode, token, cfpBaseUrl]);

  const handleChangeCompany = async (e) => {
    const selectedCompany = e.target.value;
    setSelectedCompanyCode(selectedCompany);
    setOfficeCode(selectedCompany);
    setOfficeName(getCompanies(selectedCompany) || "");

    if (code == 10 && selectedCompany) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompany);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setCircleName("");
            setFilteredDivisions([]);
            setFilteredSubDivisions([]);

            const circles = result.message.reduce((acc, curr) => {
              if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                acc.push({
                  circleCode: curr.circleCode,
                  circleName: curr.circleName,
                  companyCode: curr.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredCircles(circles);
          } else {
            setSubDivisions([]);
            setFilteredCircles([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
        setFilteredCircles([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (!selectedCompany) {
      setOfficeName("PITC");
      setCircleCode("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setCircleName("");
      setFilteredDivisions([]);
      setFilteredSubDivisions([]);
      setFilteredCircles([]);
      setSubDivisions([]);
      setApiData([]);
    }
  };

  const handleCircleChange = async (event) => {
    const selectedCircleCode = event.target.value
      ? parseInt(event.target.value)
      : "";
    if (code == 10 && selectedCircleCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("circleCode", selectedCircleCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode(selectedCircleCode);
            setOfficeCode(selectedCircleCode);
            const circle = filteredCircles.find(
              (circle) => circle.circleCode === selectedCircleCode
            );
            const circleName = circle?.circleName || "";
            setOfficeName(circleName.concat(" Circle"));
            setCircleName(circleName);
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);

            const uniqueDivisions = result.message
              .filter((item) => item.circleCode === selectedCircleCode)
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (division) => division.divisionCode === item.divisionCode
                  )
                ) {
                  acc.push({
                    divisionCode: item.divisionCode,
                    divisionName: item.divisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (code == 10 && !selectedCircleCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode("");
            setOfficeCode(selectedCompanyCode);
            setOfficeName(getCompanies(selectedCompanyCode));
            setCircleName("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);

            const uniqueDivisions = result.message.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedCircleCode) {
      setCircleCode(selectedCircleCode);
      setOfficeCode(selectedCircleCode);
      const circle = filteredCircles.find(
        (circle) => circle.circleCode === selectedCircleCode
      );
      const circleName = circle?.circleName || "";
      setOfficeName(circleName.concat(" Circle"));
      setCircleName(circleName);
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter((item) => item.circleCode === selectedCircleCode)
        .reduce((acc, item) => {
          if (
            !acc.some((division) => division.divisionCode === item.divisionCode)
          ) {
            acc.push({
              divisionCode: item.divisionCode,
              divisionName: item.divisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    } else {
      setCircleCode("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      if (roleTypeName == "Technical") {
        if (offCode) {
          setOfficeCode(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode));
          let officeName = getName(
            String(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode)),
            subDivisions
          );
          setOfficeName(officeName.concat(" Region"));
          setCircleName("");
          const circles = subDivisions.reduce((acc, curr) => {
            if (!acc.some((item) => item.circleCode === curr.circleCode)) {
              acc.push({
                circleCode: curr.circleCode,
                circleName: curr.circleName,
                companyCode: curr.companyCode,
              });
            }
            return acc;
          }, []);
          setFilteredCircles(circles);
          const uniqueDivisions = subDivisions.reduce((acc, item) => {
            if (
              !acc.some(
                (division) => division.divisionCode === item.divisionCode
              )
            ) {
              acc.push({
                divisionCode: item.divisionCode,
                divisionName: item.divisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
          setFilteredDivisions(uniqueDivisions);
        }
      } else if (roleTypeName == "Commercial") {
        if (cfcLevelId == 2) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 2));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        } else if (cfcLevelId == 3) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 3));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        }
      }
    }
  };

  const handleDivisionChange = async (e) => {
    const selectedDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedDivisionCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("divisionCode", selectedDivisionCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedDivision(selectedDivisionCode);
            setOfficeCode(selectedDivisionCode);
            const division = filteredDivisions.find(
              (division) => division.divisionCode === selectedDivisionCode
            );
            const divisionName = division?.divisionName || "";
            setOfficeName(divisionName.concat(" Division"));
            setSelectedSubDivision("");
            const uniqueSubDivisions = result.message
              .filter((item) => item.divisionCode == selectedDivisionCode)
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (sub) => sub.subDivisionCode === item.subDivisionCode
                  )
                ) {
                  acc.push({
                    subDivisionCode: item.subDivisionCode,
                    subDivisionName: item.subDivisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, []);
            setFilteredSubDivisions(uniqueSubDivisions);
          } else {
            setSubDivisions([]);
            setFilteredSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
        setFilteredSubDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedDivisionCode) {
      setSelectedDivision(selectedDivisionCode);
      setOfficeCode(selectedDivisionCode);
      const divisionName =
        filteredDivisions.find(
          (division) => division.divisionCode === selectedDivisionCode
        )?.divisionName || "";
      setOfficeName(divisionName.concat(" Division"));
      setSelectedSubDivision("");
      const uniqueSubDivisions = subDivisions
        .filter((item) => item.divisionCode == selectedDivisionCode)
        .reduce((acc, item) => {
          if (
            !acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)
          ) {
            acc.push({
              subDivisionCode: item.subDivisionCode,
              subDivisionName: item.subDivisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredSubDivisions(uniqueSubDivisions);
    } else {
      setSelectedDivision("");
      setOfficeCode(circleCode ? circleCode : offCode);
      let officeName = getName(
        circleCode ? circleCode.toString() : offCode.toString(),
        subDivisions
      );
      setOfficeName(officeName.concat(" Circle"));
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter(
          (item) => item.circleCode == (circleCode ? circleCode : offCode)
        )
        .reduce((acc, item) => {
          if (
            !acc.some((division) => division.divisionCode === item.divisionCode)
          ) {
            acc.push({
              divisionCode: item.divisionCode,
              divisionName: item.divisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    }
  };

  const handleSubDivisionChange = async (e) => {
    const selectedSubDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedSubDivisionCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("subDivisionCode", selectedSubDivisionCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedSubDivision(selectedSubDivisionCode);
            setOfficeCode(selectedSubDivisionCode);
            const subDivision = filteredSubDivisions.find(
              (sub) => sub.subDivisionCode === selectedSubDivisionCode
            );
            const subDivisionName = subDivision?.subDivisionName || "";
            setOfficeName(subDivisionName.concat(" Sub Division"));
          } else {
            setSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedSubDivisionCode) {
      setSelectedSubDivision(selectedSubDivisionCode);
      setOfficeCode(selectedSubDivisionCode);
      const subDivisionName =
        filteredSubDivisions.find(
          (sub) => sub.subDivisionCode === selectedSubDivisionCode
        )?.subDivisionName || "";
      setOfficeName(subDivisionName.concat(" Sub Division"));
    } else {
      setSelectedSubDivision("");
      let officeName = getName(
        selectedDivision ? selectedDivision.toString() : offCode.toString(),
        subDivisions
      );
      setOfficeName(officeName.concat(" Division"));
      setOfficeCode(selectedDivision ? selectedDivision : offCode);
    }
  };

  useEffect(() => {
    if (roleTypeName == "Technical") {
      if (offCode) {
        setOfficeCode(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode));
        let offName = getName(
          String(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode)),
          subDivisions
        );
        setOfficeName(offName);
        setHierarchy(offCode.toString().length);
      }
    } else if (roleTypeName == "Commercial") {
      if (cfcLevelId == 1) {
        if (offCode) {
          if (offCode == 10) {
            const effectiveCompany = getEffectiveAdminCompanyCode(
              offCode,
              selectedCompanyCode,
              selectedAdminCompanyCode,
            );
            setOfficeCode(effectiveCompany);
            setOfficeName(getCompanies(String(effectiveCompany)) || "PITC");
          } else {
            setOfficeCode(offCode);
            let offName = getName(offCode, subDivisions);
            setOfficeName(offName);
          }

          setHierarchy(offCode.length);
        }
      } else if (cfcLevelId == 2) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 2));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 3) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 3));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 4) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 4));
                    let offName = cscID;
                    setOfficeName(offName);
                    setHierarchy(cfcLevelId);
                }
            }else if (cfcLevelId == 5) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 5));
                    let offName = cscID;
                    setOfficeName(offName);
                    setHierarchy(cfcLevelId);
                }
            }
    }
  }, [offCode, cfcLevelId, roleTypeName, cscID, selectedAdminCompanyCode, selectedCompanyCode]);

  useEffect(() => {
    if (hierarchy) {
      if (hierarchy == 1 || cfcLevelId === 1) {
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 2 || cfcLevelId == 2) {
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 3 || cfcLevelId == 3) {
        setCircleCode(offCode.slice(0, 3));
        const uniqueDivisions = subDivisions
          .filter((item) => item.circleCode == offCode.slice(0, 3))
          .reduce((acc, item) => {
            if (
              !acc.some(
                (division) => division.divisionCode === item.divisionCode
              )
            ) {
              acc.push({
                divisionCode: item.divisionCode,
                divisionName: item.divisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredDivisions(uniqueDivisions);
      } else if (
        hierarchy == 4 ||
        cfcLevelId == 4 ||
        hierarchy == 5 ||
        cfcLevelId == 5
      ) {
        setSelectedDivision(offCode.slice(0, 4));
        const uniqueSubDivisions = subDivisions
          .filter((item) => item.divisionCode == offCode.slice(0, 4))
          .reduce((acc, item) => {
            if (
              !acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)
            ) {
              acc.push({
                subDivisionCode: item.subDivisionCode,
                subDivisionName: item.subDivisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredSubDivisions(uniqueSubDivisions);
      }
    }
  }, [hierarchy, cfcLevelId, subDivisions]);

  const DownloadPdf = async (print) => {
    return new Promise((resolve, reject) => {
      let offName = officeName;
      const reportTitle =
        dateFrom && dateTo && convertDate(dateFrom) === convertDate(dateTo)
          ? `Daily SR Report (COA) for (${offName})`
          : `SR Report (COA) for (${offName}) from ${
              dateFrom ? convertDate(dateFrom) : "-"
            } to ${dateTo ? convertDate(dateTo) : "-"}`;
      const headers = [
        [
          { content: "Sr No." },
          { content: "Application ID" },
          { content: "Applicant Name" },
          { content: "CNIC" },
          { content: "Account No." },
          { content: "Store Requisition No." },
          { content: "Requisition Date" },
          { content: "Status" },
        ],
      ];

      const body = [];
      if (powerComplaints && powerComplaints.length > 0) {
        const sortedComplaints = [...powerComplaints].sort(
          (a, b) => a.serialNo - b.serialNo
        );
        sortedComplaints.forEach((item) => {
          body.push([
            item.serialNo || "-",
            item.applicationId || "-",
            item.applicantName || "-",
            item.applicantCNIC || "-",
            item.connectionAccountNo || "-",
            item.storeRequisitionNo || "-",
            item.storeRequisitionDate
              ? convertDatewithTime(item.storeRequisitionDate)
              : "-",
            item.newConProgStatusName || "-",
          ]);
        });
      } else {
        body.push([
          {
            content: "No Data Found",
            styles: {
              halign: "center",
              fontSize: 10,
              fontStyle: "bold",
              fillColor: [255, 255, 255],
              textColor: [255, 0, 0],
            },
          },
        ]);
      }

      const pdf = new jsPDF("landscape", "mm", "a4", { compressPdf: true });
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const logoWidth =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        companyCode === "59"
          ? 25
          : 30;
      const logoHeight =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        companyCode === "59"
          ? 20
          : 10;
      pdf.addImage(getLogo(companyCode), "PNG", 15, 5, logoWidth, logoHeight);

      const eOpsLogoWidth = 20;
      const eOpsLogoHeight = 8;
      const eOpsLogoXPosition =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        companyCode === "59"
          ? 43
          : 17;
      pdf.addImage(
        eOpsLogo,
        "PNG",
        eOpsLogoXPosition,
        companyCode === "12" ||
          companyCode === "13" ||
          companyCode === "11" ||
          companyCode === "16" ||
          companyCode === "27" ||
          companyCode === "48" ||
          companyCode === "59"
          ? 12
          : 17,
        eOpsLogoWidth,
        eOpsLogoHeight
      );

      pdf.setFontSize(10);
      pdf.text(convertDatewithTime(new Date()), pageWidth - 65, 12);
      pdf.text("Name: " + userName, pageWidth - 65, 17);
      pdf.text("Designation: " + userRole, pageWidth - 65, 22);

      pdf.setFontSize(12);
      pdf.text(getCompanies(companyCode), pageWidth / 2, 12, {
        align: "center",
      });
      pdf.text(`SR Report (Change of Attributes)`, pageWidth / 2, 18, { align: "center" });
      pdf.setFontSize(10);
      pdf.text(reportTitle, pageWidth / 2, 25, { align: "center" });

      pdf.autoTable({
        startY: 28,
        head: headers,
        body: body,
        styles: {
          cellPadding: 1,
          fontSize: 8,
          halign: "center",
          lineWidth: 0.25,
          lineColor: "white",
        },
        margin: { top: 2 },
        theme: "striped",
        headStyles: { valign: "middle" },
        bodyStyles: { halign: "center" },
        columnStyles: {
          0: { halign: "left" },
          2: { halign: "left" },
          3: { halign: "left" },
          4: { halign: "left" },
        },
        didParseCell: (data) => {
          if (data.row.raw[0]?.content === "No Data Found") {
            data.cell.colSpan = headers[0].length;
          }
        },
      });

      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        const pageNumberText = `Page ${i} of ${totalPages}`;
        pdf.setFontSize(10);
        pdf.text(pageNumberText, pageWidth - 45, pageHeight - 10);
      }
      if (print) {
        const safeFileName = reportTitle
          .replace(/[:/\\]/g, "-")
          .replace(/\s+/g, "-");
        openJsPdfInNewTab(pdf, `${safeFileName}.pdf`);
      } else {
        resolve(pdf);
      }
    });
  };

  const printPDF = async () => {
    let pdf = await DownloadPdf(false);
    const pdfUrl = pdf.output("bloburl");
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.top = "0";
    iframe.style.left = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    const cancelButton = document.createElement("button");
    cancelButton.textContent = "Cancel";
    cancelButton.style.position = "fixed";
    cancelButton.style.top = "20px";
    cancelButton.style.right = "20px";
    cancelButton.style.padding = "10px 20px";
    cancelButton.style.backgroundColor = "#ff4d4d";
    cancelButton.style.color = "white";
    cancelButton.style.border = "none";
    cancelButton.style.borderRadius = "5px";
    cancelButton.style.cursor = "pointer";
    document.body.appendChild(cancelButton);

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    };

    cancelButton.addEventListener("click", () => {
      if (iframe.parentNode) document.body.removeChild(iframe);
      if (cancelButton.parentNode) document.body.removeChild(cancelButton);
    });
  };

  const exportToExcel = () => {
    const headers = [
      "Sr No.",
      "Application ID",
      "Applicant Name",
      "CNIC",
      "Account No.",
      "Store Requisition No.",
      "Requisition Date",
      "Status",
    ];

    const data =
      powerComplaints && powerComplaints.length > 0
        ? [...powerComplaints]
            .sort((a, b) => a.serialNo - b.serialNo)
            .map((item) => [
              item.serialNo || "-",
              item.applicationId || "-",
              item.applicantName || "-",
              item.applicantCNIC || "-",
              item.connectionAccountNo || "-",
              item.storeRequisitionNo || "-",
              item.storeRequisitionDate
                ? convertDatewithTime(item.storeRequisitionDate)
                : "-",
              item.newConProgStatusName || "-",
            ])
        : [["No Data Found", "-", "-", "-", "-", "-", "-", "-"]];

    const worksheetData = [headers, ...data];
    const reportTitle =
      dateFrom && dateTo && convertDate(dateFrom) === convertDate(dateTo)
        ? `Daily SR Report (COA) for (${officeName})`
        : `SR Report (COA) for (${officeName}) from ${
            dateFrom ? convertDate(dateFrom) : "-"
          } to ${dateTo ? convertDate(dateTo) : "-"}`;

    const ws = XLSX.utils.aoa_to_sheet([[reportTitle], [""], ...worksheetData]);
    boldRows(ws, 2, 2);
    ws["!cols"] = [
      { wch: 10 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "COA SR Report");
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const safeFileName = reportTitle
      .replace(/[:/\\]/g, "-")
      .replace(/\s+/g, "-");
    saveAs(new Blob([wbout]), `${safeFileName}.xlsx`);
  };

  useEffect(() => {
    if (powerComplaints) {
      apiToDataGridConversion();
    }
  }, [powerComplaints]);

  useEffect(() => {
    if (powerComplaints.length >= 1 && foundInNc && foundInNc !== "") {
      const ncApp = powerComplaints.find(
        (item) => item.applicationId === foundInNc
      );
      if (ncApp) {
        handleRowClick({ applicationId: foundInNc });
      }
    }
  }, [powerComplaints, foundInNc]);

  useEffect(() => {
    // SR search results must win — never clear/overwrite them from GO Redux data
    if (tableFromSrSearch) {
      setViewBackdrop(false);
      return;
    }

    if (!shouldShowData) {
      setPowerComplaintsToDataGrid([]);
      return;
    }

    if (data && Array.isArray(data)) {
      const sortedComplaints = [...data].sort((a, b) => {
        const dateA = new Date(a.storeRequisitionDate);
        const dateB = new Date(b.storeRequisitionDate);
        return Math.abs(new Date() - dateB) - Math.abs(new Date() - dateA);
      });

      setPowerComplaints(sortedComplaints);
      setViewBackdrop(false);
    }
  }, [data, shouldShowData, tableFromSrSearch]);

  useEffect(() => {
    if (code == 10 && selectedCompanyCode) {
      const fetchSubDivisions = async () => {
        setViewBackdrop(true);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        const formdata = new FormData();
        formdata.append("companyCode", selectedCompanyCode);
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: formdata,
          redirect: "follow",
        };
        try {
          const response = await fetch(
            cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
            requestOptions
          );
          if (response.ok) {
            const result = await response.json();
            if (result.status === "200") {
              setSubDivisions(result.message);
              setApiData(result.message);
              const circles = result.message.reduce((acc, curr) => {
                if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                  acc.push({
                    circleCode: curr.circleCode,
                    circleName: curr.circleName,
                    companyCode: curr.companyCode,
                  });
                }
                return acc;
              }, []);
              setFilteredCircles(circles);
            } else {
              setSubDivisions([]);
              setFilteredCircles([]);
            }
          } else {
            throw new Error(`Request failed with status ${response.status}`);
          }
        } catch (error) {
          setSubDivisions([]);
          setFilteredCircles([]);
        } finally {
          setViewBackdrop(false);
        }
      };
      fetchSubDivisions();
    } else if (code != 10) {
      const circles = subDivisions.reduce((acc, curr) => {
        if (!acc.some((item) => item.circleCode === curr.circleCode)) {
          acc.push({
            circleCode: curr.circleCode,
            circleName: curr.circleName,
            companyCode: curr.companyCode,
          });
        }
        return acc;
      }, []);
      setFilteredCircles(circles);
    }
  }, [code, selectedCompanyCode, token]);

  useEffect(() => {
    // Skip if company is already selected (for PITC users)
    if (code == 10 && selectedCompanyCode && selectedCompanyCode !== "10") {
      return;
    }
    if (roleTypeName == "Technical") {
      if (offCode) {
        setOfficeCode(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode));
        let offName = getName(
          String(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode)),
          subDivisions
        );
        setOfficeName(offName);
        setHierarchy(offCode.toString().length);
      }
    } else if (roleTypeName == "Commercial") {
      if (cfcLevelId == 1) {
        if (offCode) {
          if (offCode == 10) {
            const effectiveCompany = getEffectiveAdminCompanyCode(
              offCode,
              selectedCompanyCode,
              selectedAdminCompanyCode,
            );
            setOfficeCode(effectiveCompany);
            setOfficeName(getCompanies(String(effectiveCompany)) || "PITC");
          } else {
            setOfficeCode(offCode);
            let offName = getName(offCode, subDivisions);
            setOfficeName(offName);
          }
          setHierarchy(offCode.length);
        }
      } else if (cfcLevelId == 2) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 2));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 3) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 3));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 4) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 4));
                    let offName = cscID;
                    setOfficeName(offName);
                    setHierarchy(cfcLevelId);
                }
            }else if (cfcLevelId == 5) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 5));
                    let offName = cscID;
                    setOfficeName(offName);
                    setHierarchy(cfcLevelId);
                }
            }
    }
  }, [offCode, cfcLevelId, roleTypeName, cscID, subDivisions, code, selectedCompanyCode]);

  useEffect(() => {
    if (hierarchy) {
      if (hierarchy == 1 || cfcLevelId === 1) {
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 2 || cfcLevelId == 2) {
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 3 || cfcLevelId == 3) {
        setCircleCode(offCode.slice(0, 3));
        const uniqueDivisions = subDivisions
          .filter((item) => item.circleCode == offCode.slice(0, 3))
          .reduce((acc, item) => {
            if (
              !acc.some(
                (division) => division.divisionCode === item.divisionCode
              )
            ) {
              acc.push({
                divisionCode: item.divisionCode,
                divisionName: item.divisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredDivisions(uniqueDivisions);
      } else if (
        hierarchy == 4 ||
        cfcLevelId == 4 ||
        hierarchy == 5 ||
        cfcLevelId == 5
      ) {
        setSelectedDivision(offCode.slice(0, 4));
        const uniqueSubDivisions = subDivisions
          .filter((item) => item.divisionCode == offCode.slice(0, 4))
          .reduce((acc, item) => {
            if (
              !acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)
            ) {
              acc.push({
                subDivisionCode: item.subDivisionCode,
                subDivisionName: item.subDivisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredSubDivisions(uniqueSubDivisions);
      }
    }
  }, [hierarchy, cfcLevelId, subDivisions, offCode]);

  const tblColumns = [
    {
      field: "srNo",
      headerName: "Sr No.",
      align: "center",
      sortable: false,
      filterable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "applicationId",
      headerName: "Application ID",
      align: "center",
      sortable: false,
      filterable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "applicantName",
      headerName: "Applicant Name",
      align: "left",
      sortable: false,
      filterable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "applicantCNIC",
      headerName: "CNIC",
      align: "left",
      sortable: false,
      filterable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "connectionAccountNo",
      headerName: "Account No.",
      align: "left",
      sortable: false,
      filterable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "storeRequisitionNo",
      headerName: "Store Requisition No.",
      align: "center",
      sortable: false,
      filterable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "storeRequisitionDate",
      headerName: "Store Requisition Date",
      align: "center",
      sortable: false,
      filterable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "newConProgStatusName",
      headerName: "Status",
      align: "center",
      sortable: false,
      filterable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },

    {
      field: "select",
      headerName: "Select",
      align: "center",
      sortable: false,
      filterable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
      renderCell: (row) => {
        const storeReqNo = row?.storeRequisitionNo;

        return (
          <input
            type="checkbox"
            checked={selectedRequisitions.some(
              (item) => item.Store_Requisition_No === storeReqNo
            )}
            onChange={(e) => {
              const isChecked = e.target.checked;

              if (!storeReqNo) {
                return;
              }

              if (isChecked) {
                setSelectedRequisitions((prev) => [
                  ...prev,
                  { Store_Requisition_No: storeReqNo },
                ]);
              } else {
                setSelectedRequisitions((prev) =>
                  prev.filter(
                    (item) => item.Store_Requisition_No !== storeReqNo
                  )
                );
              }
            }}
          />
        );
      },
    },
  ];

  useScanDetection({
    onComplete: async (code) => {
      if (code) {
        code = code.replace(/Shift/g, "");
        const regex = /^[A-Z]{2}-\d{14,15}$/;
        if (regex.test(code)) {
          await handleRowClick({ applicationId: code });
        } else {
        }
      }
    },
    minLength: 4,
  });

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const onPressSendEmail = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        Email: email,
        Store_Requisition_No: selectedRequisitions,
      });

      // TODO: Update endpoint for COA if different
      const response = await fetch(cfpBaseUrl + "enc/sendSROnEmail", {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      });

      const result = await response.json();

      if (result.status === "200") {
        setSnackbar({
          open: true,
          message: result.message || "Email sent successfully!",
          severity: "success",
        });
        setEmailPopupOpen(false);
        setEmail("");
      } else {
        setSnackbar({
          open: true,
          message: result.message || "Something went wrong!",
          severity: "error",
        });
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: "Network error. Please try again.",
        severity: "error",
      });
    }
  };

  useEffect(() => {
    if (!lastAppliedFilters) {
      setIsGoDisabled(false);
      return;
    }

    const hasFilterChanged =
      dateFrom !== lastAppliedFilters.dateFrom ||
      dateTo !== lastAppliedFilters.dateTo ||
      selectedCompanyCode !== lastAppliedFilters.selectedCompanyCode ||
      circleCode !== lastAppliedFilters.circleCode ||
      selectedDivision !== lastAppliedFilters.selectedDivision ||
      selectedSubDivision !== lastAppliedFilters.selectedSubDivision;

    setIsGoDisabled(!hasFilterChanged);
  }, [
    dateFrom,
    dateTo,
    selectedCompanyCode,
    circleCode,
    selectedDivision,
    selectedSubDivision,
    lastAppliedFilters,
  ]);

  const handleGoClick = () => {
    const reportOfficeCode = resolveReportGoOfficeCode({
      code,
      officeCode,
      selectedCompanyCode,
      selectedAdminCompanyCode,
      circleCode,
      selectedDivision,
      selectedSubDivision,
    });
    resetTableData();
    setTableFromSrSearch(false);
    setPowerComplaints([]);
    setPowerComplaintsToDataGrid([]);

    fetchData(
      1,
      pageSize,
      convertDateYYYYMMDD(dateFrom),
      convertDateYYYYMMDD(dateTo),
      officeCode
    );

    getLineDataComplaints(reportOfficeCode, hierarchy);

    setLastAppliedFilters({
      dateFrom,
      dateTo,
      selectedCompanyCode,
      circleCode,
      selectedDivision,
      selectedSubDivision,
    });

    setShouldShowData(true);

    setIsGoDisabled(true);
  };

  const handleSearchBySRNo = async () => {
    if (!searchSRNo.trim()) {
      setSnackbar({
        open: true,
        message: "Please enter Store Requisition No. or Application ID.",
        severity: "warning",
      });
      return;
    }

    const searchedSrNo = searchSRNo.trim();
    setViewBackdrop(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        pageNumber: 1,
        pageSize: 20,
        officeCode: officeCode.toString(),
        dateFrom: convertDateYYYYMMDD(dateFrom),
        dateTo: convertDateYYYYMMDD(dateTo),
        searchById: searchedSrNo,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        "https://eopsapi.pitc.com.pk/changeOfAttributes/getCOASRDataForEmail",
        requestOptions
      );
      const result = await response.json();

      if (
        (result.status === "200" || result.status === 200) &&
        Array.isArray(result.data) &&
        result.data.length > 0
      ) {
        const dataWithSerialNo = result.data.map((item, index) => ({
          ...item,
          serialNo: index + 1,
        }));
        // Flag first so GO-sync effect cannot clear these rows
        setTableFromSrSearch(true);
        setShouldShowData(true);
        setPowerComplaints(dataWithSerialNo);
      } else {
        setTableFromSrSearch(false);
        setPowerComplaints([]);
        setPowerComplaintsToDataGrid([]);
        setSnackbar({
          open: true,
          message: result.message || "No records found",
          severity: "info",
        });
      }
    } catch (error) {
      setTableFromSrSearch(false);
      setSnackbar({
        open: true,
        message: "Error searching. Please try again.",
        severity: "error",
      });
    } finally {
      setViewBackdrop(false);
    }
  };

  const FilterFieldLabel = ({ htmlFor, children }) => (
    <Typography
      component="label"
      variant="body2"
      htmlFor={htmlFor}
      sx={{
        fontWeight: 600,
        color: "text.secondary",
        display: "block",
        mb: 0.5,
        lineHeight: 1.35,
      }}
    >
      {children}
    </Typography>
  );

  const tableCaptionText =
    dateFrom && dateTo && convertDate(dateFrom) === convertDate(dateTo)
      ? `Daily SR Report (COA) for (${officeName})`
      : `SR Report (COA) for (${officeName}) from ${
          dateFrom ? convertDate(dateFrom) : "-"
        } to ${dateTo ? convertDate(dateTo) : "-"}`;

  const renderFilters = ({ showGo = false } = {}) => (
    <Grid
      container
      spacing={2}
      alignItems="flex-start"
      className="coa-filters-grid-wrap"
    >
      <Grid item xs={12} sm={6} md={2}>
        <Stack spacing={0.5}>
          <FilterFieldLabel htmlFor="coa-sr-date-from">Date From</FilterFieldLabel>
          <TextField
            id="coa-sr-date-from"
            fullWidth
            size="small"
            variant="outlined"
            type="date"
            value={dateFrom}
            inputProps={getReportDateInputProps()}
            onChange={(e) => setDateFrom(clampIsoDateToToday(e.target.value))}
          />
        </Stack>
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <Stack spacing={0.5}>
          <FilterFieldLabel htmlFor="coa-sr-date-to">Date To</FilterFieldLabel>
          <TextField
            id="coa-sr-date-to"
            fullWidth
            size="small"
            variant="outlined"
            type="date"
            value={dateTo}
            inputProps={getReportDateInputProps()}
            onChange={(e) => setDateTo(clampIsoDateToToday(e.target.value))}
          />
        </Stack>
      </Grid>
      {code == 10 && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5}>
            <FilterFieldLabel htmlFor="coa-sr-company">Company</FilterFieldLabel>
            <FormControl fullWidth size="small" variant="outlined">
              <Select
                id="coa-sr-company"
                displayEmpty
                value={selectedCompanyCode || ""}
                onChange={handleChangeCompany}
              >
                <MenuItem value="">
                  <em>Select Company</em>
                </MenuItem>
                {getDiscoCompanyMenuItems(selectedCompanyCode)}
              </Select>
            </FormControl>
          </Stack>
        </Grid>
      )}
      {hierarchy <= 2 && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5}>
            <FilterFieldLabel htmlFor="coa-sr-circle">Circle</FilterFieldLabel>
            <FormControl fullWidth size="small" variant="outlined">
              <Select
                id="coa-sr-circle"
                displayEmpty
                value={circleCode === "" || circleCode === undefined || circleCode === null ? "" : circleCode}
                onChange={handleCircleChange}
                renderValue={(v) => renderCircleValue(v, filteredCircles)}
              >
                <MenuItem value="">
                  <em>All Circle</em>
                </MenuItem>
                {filteredCircles.map((circle) => (
                  <MenuItem key={circle.circleCode} value={circle.circleCode}>
                    {circle.circleName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Grid>
      )}
      {hierarchy <= 3 && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5}>
            <FilterFieldLabel htmlFor="coa-sr-division">Division</FilterFieldLabel>
            <FormControl fullWidth size="small" variant="outlined">
              <Select
                id="coa-sr-division"
                displayEmpty
                value={
                  selectedDivision === "" ||
                  selectedDivision === undefined ||
                  selectedDivision === null
                    ? ""
                    : selectedDivision
                }
                onChange={handleDivisionChange}
                disabled={!circleCode}
                renderValue={(v) => renderDivisionValue(v, filteredDivisions)}
              >
                <MenuItem value="">
                  <em>All Division</em>
                </MenuItem>
                {filteredDivisions.map((division) => (
                  <MenuItem key={division.divisionCode} value={division.divisionCode}>
                    {division.divisionName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Grid>
      )}
      {hierarchy <= 4 && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5}>
            <FilterFieldLabel htmlFor="coa-sr-subdiv">Sub-Division</FilterFieldLabel>
            <FormControl fullWidth size="small" variant="outlined">
              <Select
                id="coa-sr-subdiv"
                displayEmpty
                value={
                  selectedSubDivision === "" ||
                  selectedSubDivision === undefined ||
                  selectedSubDivision === null
                    ? ""
                    : selectedSubDivision
                }
                onChange={handleSubDivisionChange}
                disabled={!selectedDivision}
                renderValue={(v) =>
                  renderSubDivisionValue(v, filteredSubDivisions)
                }
              >
                <MenuItem value="">
                  <em>All Sub-Division</em>
                </MenuItem>
                {filteredSubDivisions.map((subDivision) => (
                  <MenuItem
                    key={subDivision.subDivisionCode}
                    value={subDivision.subDivisionCode}
                  >
                    {subDivision.subDivisionName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Grid>
      )}
      {showGo && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5} sx={{ pt: "2px" }}>
            <Box
              aria-hidden
              sx={{
                height: "1.35rem",
                mb: 0.5,
                lineHeight: 1.35,
              }}
            />
            <Button
              id="coa-sr-go-btn"
              fullWidth
              variant="contained"
              disableElevation
              className="coa-go-btn"
              onClick={handleGoClick}
              disabled={isGoDisabled || viewBackdrop}
            >
              GO
            </Button>
          </Stack>
        </Grid>
      )}
    </Grid>
  );

  const noDataAvailable = () => {
    alert("No data available to export or print.");
  };

  return (
    <>
      <Box className="form-box rpt-page coa-status-report sr-coa-details-page">
        <div className="coa-layout">
          <header className="coa-page-header">
            <h1 className="coa-page-title">SR Change of Attributes Details</h1>
          </header>

          <div className="coa-toolbar-stack">
            <Paper
              variant="outlined"
              className="coa-card coa-card--filters"
              sx={{
                p: 2,
                width: "100%",
                bgcolor: "#fff",
                borderRadius: 2,
                borderColor: "divider",
              }}
            >
              <div
                className={
                  isMdUp ? "coa-filters coa-filters--mui-grid" : "coa-filters"
                }
              >
                {isMdUp ? (
                  renderFilters({ showGo: true })
                ) : (
                  <p className="coa-filters-hint">
                    Tap <strong>Filters</strong> to set dates and office, then tap{" "}
                    <strong>GO</strong>.
                  </p>
                )}
              </div>

              {/* Search moved into export strip for same-row layout */}

              <Stack
                direction="row"
                flexWrap="wrap"
                alignItems="center"
                justifyContent={{ xs: "flex-start", md: "space-between" }}
                spacing={1}
                className="coa-export-strip"
                sx={{
                  pt: 2,
                  mt: 2,
                  borderTop: "1px solid",
                  borderColor: "divider",
                  gap: 1,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mr: { xs: 0, md: 'auto' } }}>
                  <Box
                    sx={{
                      backgroundColor: "#f0f7ff",
                      border: "1px solid #1976d2",
                      borderRadius: "8px",
                      padding: "8px 15px",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      boxShadow: "0 2px 4px rgba(25, 118, 210, 0.15)",
                      flexWrap: "wrap",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "#1976d2",
                        fontWeight: 600,
                        fontSize: "14px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Search SR No. / Application ID:
                    </Typography>
                    <Box sx={{ position: "relative" }}>
                      <input
                        type="text"
                        value={searchSRNo}
                        onChange={(e) => setSearchSRNo(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            handleSearchBySRNo();
                          }
                        }}
                        placeholder="Enter SR No. or Application ID"
                        style={{
                          backgroundColor: "white",
                          border: "1px solid #1976d2",
                          borderRadius: "6px",
                          padding: "8px 35px 8px 12px",
                          width: "260px",
                          fontSize: "14px",
                          outline: "none",
                        }}
                      />
                      {searchSRNo && (
                        <span
                          role="button"
                          tabIndex={0}
                          onClick={() => {
                            setSearchSRNo("");
                            setTableFromSrSearch(false);
                            if (lastAppliedFilters) {
                              fetchData(
                                1,
                                pageSize,
                                convertDateYYYYMMDD(lastAppliedFilters.dateFrom),
                                convertDateYYYYMMDD(lastAppliedFilters.dateTo),
                                officeCode
                              );
                            }
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                              e.preventDefault();
                              setSearchSRNo("");
                              setTableFromSrSearch(false);
                            }
                          }}
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            color: "#1976d2",
                            fontSize: "18px",
                            fontWeight: "bold",
                            lineHeight: "1",
                          }}
                        >
                          x
                        </span>
                      )}
                    </Box>
                    <Button
                      variant="contained"
                      onClick={handleSearchBySRNo}
                      disabled={viewBackdrop || !searchSRNo.trim()}
                      sx={{
                        background: "linear-gradient(180deg, #1DB6E8, #003971)",
                        borderRadius: "6px",
                        padding: "6px 20px",
                        textTransform: "none",
                        fontWeight: "600",
                        "&:hover": {
                          background: "linear-gradient(180deg, #1aa3d1, #002a5c)",
                        },
                        "&:disabled": {
                          background: "#ccc",
                        },
                      }}
                    >
                      Search
                    </Button>
                  </Box>
                </Box>
                {!isMdUp && (
                  <Tooltip title="Filters">
                    <IconButton
                      color="primary"
                      onClick={() => setMobileFilterOpen(true)}
                      aria-label="Open filters"
                      size="small"
                    >
                      <FilterListIcon />
                    </IconButton>
                  </Tooltip>
                )}
                {!isMdUp && (
                  <Button
                    variant="contained"
                    disableElevation
                    className="coa-go-btn"
                    size="small"
                    onClick={handleGoClick}
                    disabled={isGoDisabled || viewBackdrop}
                  >
                    GO
                  </Button>
                )}
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <ReportExportButtons
                    isEmpty={!powerComplaints || powerComplaints.length === 0}
                    onEmpty={noDataAvailable}
                    onPdf={() => DownloadPdf(true)}
                    onExcel={exportToExcel}
                    onPrint={printPDF}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    sx={{ textTransform: "none", fontWeight: 600 }}
                    onClick={() => setEmailPopupOpen(true)}
                  >
                    Send on Email
                  </Button>
                </Box>
              </Stack>
            </Paper>
          </div>

          <div className="coa-report-banner" role="status">
            {tableCaptionText}
          </div>

          {isPhone && (!powerComplaintsToDataGrid || powerComplaintsToDataGrid.length === 0) && (
            <div className="coa-mobile-stack">
              <div className="coa-mobile-empty" role="status">
                No data for this run. Open <strong>Filters</strong>, tap <strong>GO</strong>,
                or search by SR number.
              </div>
            </div>
          )}

          <Box
            className="application-table"
            sx={{ width: "100%", maxWidth: "100%", minWidth: 0 }}
          >
            <div className="div-datagrid">
              <div className="coa-table-panel">
                <div
                  className="coa-table-scroll coa-basic-table-scroll"
                  id="pdf-table"
                >
                  <BasicTable
                    data={powerComplaintsToDataGrid}
                    columns={tblColumns}
                    handleRowClick={(params) => {
                      handleRowClick(params);
                    }}
                    sx={tableStyle}
                    rowHeight={37.5}
                    pageSize={pageSize}
                    rowsPerPageOptions={[18, 30, 60]}
                    nextPage={handleNextPage}
                    firstPage={handleFirstPage}
                    lastPage={handleLastPage}
                    previousPage={handlePreviousPage}
                    totalPages={totalPages}
                    totalRecords={totalRecords}
                    currentPage={pageNumber}
                    rowsPageOption={false}
                    getRowStyle={(params) => {
                      return params.indexRelativeToCurrentPage % 2 === 0
                        ? tableStyle.evenRow
                        : tableStyle.oddRow;
                    }}
                    isLoading={isLoading}
                  />
                </div>
              </div>
            </div>
          </Box>

          <Drawer
            anchor="left"
            open={mobileFilterOpen}
            onClose={() => setMobileFilterOpen(false)}
            PaperProps={{
              className: "coa-filter-drawer",
              sx: {
                width: { xs: "100%", sm: 400 },
                maxWidth: "100vw",
                boxSizing: "border-box",
              },
            }}
          >
            <Box
              className="coa-drawer-inner"
              sx={{ p: 2, pb: 3, boxSizing: "border-box" }}
            >
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{ mb: 2 }}
              >
                <Typography variant="h6" component="div">
                  Filters
                </Typography>
                <IconButton
                  aria-label="Close filters"
                  onClick={() => setMobileFilterOpen(false)}
                  edge="end"
                  size="small"
                >
                  <CloseIcon />
                </IconButton>
              </Stack>
              {renderFilters({ showGo: true })}
            </Box>
          </Drawer>
        </div>
      </Box>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <AppLoader />
      </Backdrop>
      <Dialog
        open={emailPopupOpen}
        onClose={() => setEmailPopupOpen(false)}
        fullWidth={true}
        maxWidth="sm"
        className="alert-popups"
      >
        <DialogTitle
          style={{
            background: "linear-gradient(180deg, #1DB6E8, #003971)",
            color: "white",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Send SR Report (COA) via Email
          <img
            src={closeIconWhite}
            alt="close"
            style={{ width: 25, height: 25, cursor: "pointer" }}
            onClick={() => setEmailPopupOpen(false)}
          />
        </DialogTitle>

        <DialogContent style={{ backgroundColor: "#f2f3f5" }}>
          <Grid container spacing={2} sx={{ marginTop: "10px" }}>
            <Grid item xs={12}>
              <Typography sx={{ color: "gray", marginBottom: "10px" }}>
                Enter Email Address
              </Typography>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{
                  width: "95%",
                  padding: "10px",
                  border: "1px solid #d3d3d3",
                  borderRadius: "5px",
                  backgroundColor: "white",
                }}
                placeholder="example@domain.com"
              />
            </Grid>

            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                marginTop: "20px",
              }}
            >
              <Button
                variant="contained"
                color="secondary"
                onClick={() => setEmailPopupOpen(false)}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={onPressSendEmail}
                disabled={!email}
              >
                Send
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        sx={{
          mt: 10,
        }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          variant="filled"
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
});

export default COASRonEmail;
